import React, { useEffect, useRef } from 'react';
import T from 'prop-types';

import EndDatePicker from './EndDatePicker';
import RecipientsSelect from './RecipientsSelect';
import FrequencyDropdown from './FrequencyDropdown';
import Button from '../../../../Buttons/Button';
import InputText from '../../../../Inputs/InputText';

const FormModalContent = ({
  extraReportState,
  allowedDomains,
  setExtraReportState,
  setStep,
  onBackToEdit,
}) => {
  const inputTextRef = useRef();
  const isReviewDisabled = !extraReportState.name?.trim();

  // Effects
  useEffect(() => {
    // Select input text on open
    inputTextRef.current.select();
  }, []);

  return (
    <>
      <div className="schedule-export-modal__content">
        <div className="d-flex flex-column align-items-start gap-8">
          <p className="text-12 text-quiet l-h-xxs">Export Name</p>
          <InputText
            ref={inputTextRef}
            placeholder="Export Name"
            value={extraReportState.name}
            onChange={(value) =>
              setExtraReportState((prevState) => ({ ...prevState, name: value }))
            }
          />
        </div>
        <div className="d-flex flex-column align-items-start gap-8">
          <div className="d-flex align-items-center gap-16 custom-fields-grid">
            <div className="d-flex flex-column align-items-start gap-8">
              <p className="text-12 text-quiet l-h-xxs">Frequency</p>
              <FrequencyDropdown
                selected={extraReportState.frequency}
                onChange={(value) =>
                  setExtraReportState((prevState) => ({ ...prevState, frequency: value }))
                }
              />
            </div>
            <div className="d-flex flex-column align-items-start gap-8">
              <p className="text-12 text-quiet l-h-xxs">End Date</p>
              <EndDatePicker
                value={extraReportState.schedule_expires_at}
                onChange={(value) =>
                  setExtraReportState((prevState) => ({ ...prevState, schedule_expires_at: value }))
                }
              />
            </div>
          </div>
          <p className="text-12 text-secondary text-left">
            Each scheduled run updates the end date to the latest available date and regenerates the
            export with the most current data.
          </p>
        </div>
        <div className="d-flex flex-column align-items-start gap-8">
          <p className="text-12 text-quiet l-h-xxs">Recipients</p>
          <RecipientsSelect
            selected={extraReportState.recipients}
            allowedDomains={allowedDomains}
            onChange={(value) =>
              setExtraReportState((prevState) => ({ ...prevState, recipients: value }))
            }
          />
        </div>
      </div>
      <div className="schedule-export-modal__footer">
        <Button variant="secondary" size="lg" onClick={onBackToEdit}>
          Edit Export
        </Button>
        <Button size="lg" disabled={isReviewDisabled} onClick={() => setStep('confirmation')}>
          Review
        </Button>
      </div>
    </>
  );
};

FormModalContent.propTypes = {
  extraReportState: T.shape({
    name: T.string.isRequired,
    schedule_expires_at: T.string.isRequired,
    frequency: T.string.isRequired,
    recipients: T.array.isRequired,
  }).isRequired,
  allowedDomains: T.array.isRequired,
  setExtraReportState: T.func.isRequired,
  setStep: T.func.isRequired,
  onBackToEdit: T.func.isRequired,
};

export default FormModalContent;
